import { Box, ButtonV2, Flex, TextV2 } from '@withjoy/joykit';
import { pxToRem } from '@withjoy/joykit/theme';
import React, { useMemo } from 'react';
import { useEventCallback } from '@shared/utils/hooks/useEventCallback';
import { useTranslation } from '@shared/core';

import { AccommodationsPushStepProps } from './AccommodationsPushStep.types';
import { useThanksForRSVPTelemetry } from '@apps/thanksForRsvp/ThanksForRSVP.telemetry';
import { HasOwnAccommodationsCohortView } from './HasOwnAccommodationsCohortView';
import { NoAccommodationsOrTravelCohortView } from './NoAccommodationsOrTravelCohortView';

export const AccommodationsPushStep = (props: AccommodationsPushStepProps) => {
  const { cohort, goForward } = props;
  const { t } = useTranslation('thanksForRSVP');

  const { accommodationPushStepButtonClick } = useThanksForRSVPTelemetry({ page: 'accommodationsPushStep' });

  const transAccommodationsStep = useMemo(() => {
    return t('accommodationsPushStep');
  }, [t]);

  const handleOnSkipClick = useEventCallback(() => {
    accommodationPushStepButtonClick({ cta: 'skip', cohort });
    goForward();
  });

  const content =
    cohort === 'hasOwnAccommodations' ? (
      <HasOwnAccommodationsCohortView {...props} />
    ) : cohort === 'hasNoAccommodationsAndTravelPages' ? (
      <NoAccommodationsOrTravelCohortView {...props} />
    ) : null;

  return (
    <Flex flexDirection="column" alignItems="center" justifyContent="center" minHeight="100vh" paddingY={[7, null, pxToRem(56)]} paddingX={[6, null, 0]}>
      <Flex minHeight="100%" flexDirection="column" alignItems="center" justifyContent="center" width="100%" maxWidth={['100%', null, '540px']}>
        <Flex flexDirection="column" alignItems="center" marginTop={9} maxWidth={400} paddingBottom={9}>
          {content}

          <Box marginTop={7} textAlign="center" width="100%">
            <TextV2 typographyVariant="body1" color="mono12">
              {transAccommodationsStep.footer.message()}
            </TextV2>
            <ButtonV2 marginTop={4} variant="ghost" intent="neutral" shape="rounded" fullWidth onClick={handleOnSkipClick}>
              {transAccommodationsStep.footer.ctaText()}
            </ButtonV2>
          </Box>
        </Flex>
      </Flex>
    </Flex>
  );
};
